import Service from "../../AuthService";
const ProductType = {
    getProductType() {
        return Service.get("/product-type");
    }
};
export default ProductType;
